import type ModalConversationInterceptorService from '../../modals/modal-conversation-interceptor.service';

export class ExemplarInterceptorRegistrar {

    constructor(private modalConversationInterceptor: ModalConversationInterceptorService) {
    }

    public register() {
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('ExemplarHasInvoiceItemsException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('ExemplarHasLoanHistoryException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('ExemplarInExchangeFondsHistoryException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('ExemplarHasSuppliedIssuesHistoryException');
    }

}
